import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Clock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// ISO (any zone) → value for <input type="datetime-local"> in the admin's local zone
const toLocal = (iso) => { const d = new Date(iso); const p = (n) => String(n).padStart(2, "0"); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`; };

export const DropSettings = ({ headers }) => {
  const [drop, setDrop] = useState(null);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(`${API}/drop`).then((r) => { setDrop(r.data); setValue(toLocal(r.data.closes_at)); }).catch(() => {}); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await axios.put(`${API}/admin/drop`, { closes_at: new Date(value).toISOString(), timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }, { headers });
      setDrop(r.data);
      toast.success("Pre-order close date updated — countdown live on the homepage");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save.");
    } finally {
      setSaving(false);
    }
  };

  const daysLeft = drop ? Math.ceil((new Date(drop.closes_at) - Date.now()) / 86400000) : null;
  return (
    <form onSubmit={save} data-testid="drop-settings" className="rounded-3xl border border-[#e3e2dc] bg-[#faf9f6] p-5 sm:p-6 mb-6 flex flex-wrap items-end gap-4">
      <div className="flex-1 min-w-[220px]">
        <p className="font-mono-d text-[10px] uppercase tracking-[0.25em] text-[#5f5e5a] flex items-center gap-2"><Clock size={11} className="text-[#ff2a85]" /> Pre-orders close</p>
        <p data-testid="drop-settings-status" className="font-display font-extrabold uppercase text-lg leading-tight mt-1">
          {!drop ? "…" : drop.closed ? "Closed — countdown shows “Pre-orders closed”" : `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`}
        </p>
        <p className="text-[11px] text-[#5f5e5a] mt-1">Drives the homepage ticker, hero countdown and quick-view chip. Checkout stays open either way.</p>
      </div>
      <input data-testid="drop-settings-input" type="datetime-local" required value={value} onChange={(e) => setValue(e.target.value)} className="h-11 px-4 rounded-full bg-white border border-[#e3e2dc] text-sm outline-none focus:border-[#ff2a85]/60" />
      <button data-testid="drop-settings-save" type="submit" disabled={saving || !value} className="h-11 px-5 rounded-full bg-[#0a0a0b] hover:bg-[#ff2a85] text-white font-mono-d text-[10px] uppercase tracking-[0.2em] flex items-center gap-2 disabled:opacity-50 transition-colors">
        {saving && <Loader2 size={12} className="animate-spin" />} Save date
      </button>
    </form>
  );
};
